import { configureStore } from "@reduxjs/toolkit";
import loginSlice  from "./reducer/authSlice";
import userSlice from "./reducer/userSlice";
import companySlice from "./reducer/companySlice";
import departmentSlice from "./reducer/departmentSlice";
import machineSlice from "./reducer/machineSlice";
import workSlice from "./reducer/workSlice";
import worktrackSlice from "./reducer/worktrackSlice";
import clientSlice from "./reducer/clientSlice";
import punchinSlice from "./reducer/punchinSlice";
import reportSlice from "./reducer/reportSlice";
import dashboardSlice from "./reducer/dashboardSlice";
import printQRSlice from "./reducer/printQRSlice";

export const store = configureStore({
    reducer: {
        login:loginSlice,
        user:userSlice,
        company:companySlice,
        department:departmentSlice,
        machine:machineSlice,
        work:workSlice,
        workTrack:worktrackSlice,
        client:clientSlice,
        punch:punchinSlice,
        report:reportSlice,
        dashboard:dashboardSlice,
        printQR:printQRSlice,
    }
})